import { useTranslation } from '@/hooks/useTranslation';
import { Linkedin, Github, Twitter, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.jpg';
import { CX_SERVICE_SLUGS } from '@/pages/cx/cxData';

const Footer = () => {
  const { t } = useTranslation();

  const socials = [
    { icon: Linkedin, href: '#' },
    { icon: Github, href: '#' },
    { icon: Twitter, href: '#' },
    { icon: Mail, href: 'mailto:contact@add-individual-solutions.com' },
  ];

  return (
    <footer className="site-footer">
      <div className="footer-top">
        {/* Brand */}
        <div className="f-brand">
          <img src={logo} alt="ADD Individual Solutions" width={77} height={36} loading="lazy" decoding="async" style={{ height: '36px', objectFit: 'contain', marginBottom: '18px' }} />
          <p>{t.footer.tagline}</p>
          <div className="f-socials">
            {socials.map((s, i) => (
              <a key={i} href={s.href} className="f-social">
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div className="f-col">
          <h5>{t.footer.services.title}</h5>
          <ul>
            {t.footer.services.links.map((link, i) => (
              <li key={i}><a href="/#services">{link}</a></li>
            ))}
          </ul>
          <h5 style={{ marginTop: '26px' }}>{t.footer.cx.title}</h5>
          <ul>
            {t.footer.cx.links.map((link, i) => (
              <li key={i}><Link to={`/cx/services/${CX_SERVICE_SLUGS[i]}`}>{link}</Link></li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div className="f-col">
          <h5>{t.footer.company.title}</h5>
          <ul>
            <li><a href="/#about">{t.footer.company.links[0]}</a></li>
            <li><a href="/#team">{t.footer.company.links[1]}</a></li>
            <li><Link to="/blog">{t.footer.company.links[2]}</Link></li>
            <li><Link to="/experience-lab">{t.footer.company.links[3]}</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div className="f-col">
          <h5>{t.footer.legal.title}</h5>
          <ul>
            <li><Link to="/privacy">{t.footer.legal.links[0]}</Link></li>
            <li><Link to="/terms">{t.footer.legal.links[1]}</Link></li>
            <li><Link to="/cookies">{t.footer.legal.links[2]}</Link></li>
            <li><Link to="/gdpr">{t.footer.legal.links[3]}</Link></li>
          </ul>
        </div>
      </div>

      <div className="f-bottom">
        <p>{t.footer.copyright}</p>
        <p>{t.footer.madeWith}</p>
      </div>
    </footer>
  );
};

export default Footer;
